import { createFileRoute } from '@tanstack/react-router'
import { ComplianceRuleDetailPage } from '../../../components/ComplianceRuleDetailPage'

export const Route = createFileRoute('/$org/compliance-rules/$ruleUid')({
  component: ComplianceRuleDetail,
})

function ComplianceRuleDetail() {
  return <ComplianceRuleDetailPage />
}
